import { gql } from '@apollo/client';

export const createAuditMutation = gql`
  mutation createAudit(
    $barcode: String,
    $comment: String,
    $createdBy: String,
    $createdOn: DateTime,
    $lastUpdatedBy: String,
    $updatedOn: DateTime,
    $requestId: Float,
    $entryType: String
  ) {
    createAudit(
      comment: {
        barcode: $barcode
        comment: $comment
        createdBy: $createdBy
        createdOn: $createdOn
        lastUpdatedBy: $lastUpdatedBy
        updatedOn: $updatedOn
        requestId: $requestId
        entryType: $entryType
      }
    ) {
      id
    }
  }
`;

export const updateTransferMutation = gql`
  mutation updateTransfer($input: EnterpriseOneUpdateInput!, $update: Boolean, $user: String) {
    updateTransfer(input: $input, update: $update, user: $user){
      id
    }
  }
`;

export const checkForAssetNumber = gql`
  query readFixedAsset($barCode: String!, $serialNumber: String!) {
    readFixedAsset(barCode: $barCode, serialNumber: $serialNumber){
      assetNumber
      barCode
      serialNumber
    }
  }
`;

export const updateSalvageMutation = gql`
  mutation updateSalvage($input: SalvageInput!, $approval: Int!, $update: Boolean) {
    updateSalvage(input: $input, approval: $approval, update: $update) {
      salvageId
    }
  }
`;

export const GET_REQUEST_FY_BY_BARCODE = gql`
  query readRequestFYByBarcode($barcode: String!) {
    readRequestFYByBarcode(barcode: $barcode) {
      requestId
      requestNumber
    }
  }
`;

export const allDepartmentDropdown = gql`
  query {
    readDepartments {
      id
      Abbreviation
      Name
    }
  }
`;
